
export class BaseComponent {

    language: any;
    i18n

    constructor() {
        this.i18n = this.getLanguage();
    }

    pt_BR: any = {
        HOME: {
            TITLE: "BEM-VINDO",
            TEST_FREE: "TESTAR 14 GRÁTIS",
            TEST_14_FREE: "TESTAR GRÁTIS 14 DIAS",
            NO_NEED_CREDIT_CARD: "* Não é necessário cartão de crédito",
            HELP_COMPANY: "O funil que vai ajudar a sua empresa a economizar e ter mais agilidade",
            TEXT_ENTER: "ENTRAR",
            FORGET_PASSWORD: "ESQUECEU A SENHA? CLIQUE AQUI",
            ACCESS_ACCOUNT: "ACESSE SUA CONTA",
            CHOICE_RIGHT: "Faça a escolha certa, contrate uma assinatura digital de qualidade e validade jurídica garantida.",
            REGISTER: "Cadastre-se",
            HAVE_ACCOUNT: "JÁ TEM CONTA? ACESSE AQUI",
            CREATE: "CRIAR",
            COMPLETE_NAME: "nome completo",
            CORPORATIVE_EMAIL: "email corporativo",
            USER_NAME: "nome de usuário",
            PASSWORD: "senha",
            COMPANY_NAME: "nome da empresa",
            COMPANY_DOCUMENT: "CNPJ da empresa",
            THE_SOFTWARE: "O SOFTWARE",
            PRICE: "PREÇO",
            CONTENT: "CONTEÚDO",
            ABOUT: "SOBRE NÓS",
            CONTACT: "CONTATO",
            CHANGE_LANGUAGE: "MUDAR LÍNGUA"
        },
        SIGNATURE: {
            ASSINAR_COMO: 'Assinar como ',
            NOME_COMO_NO_CPF: 'Nome completo (conforme CPF)',
            NUMERO_CPF: 'CPF',
            DOCUMENTO_INVALIDO: 'Documento inválido',
            DATA_DE_NASCIMENTO: 'Data de nascimento',
            ESTOU_DE_ACORDO: 'ESTOU DE ACORDO - ASSINAR',
            CANCELAR: 'Cancelar',
            PRE_TERMOS_DE_USO: 'ao efetuar sua assinatura você concorda com os',
            TERMOS_DE_USO: 'termos de uso',
            AMBIENTE_SEGURO: 'Ambiente seguro GoContratos',
            EVENTOS_DO_DOCUMENTO: 'Eventos do documento',
            ASSINOU_COMO: 'assinou como ',
            VER_ASSINANTES: 'VER ASSINANTES',
            PENDENTE: 'PENDENTE',
            ASSINOU_COMO_UPERCASE: 'ASSINOU COMO ',
            SEU_DOCUMENTO: 'SEU DOCUMENTO',
            ASSINAR_COMO_UPERCASE: 'ASSINAR COMO ',
            DOWNLOAD_PDF: 'Documento assinado (PDF)',
            DOWNLOAD_ZIP: 'Documento original (PDF)',
            SUA_ASSINATURA_USE: 'Sua assinatura ( use',
            OU: 'ou',
            PARA_ASSINAR: 'para assinar',
            LIMPAR: 'limpar',
            DESENHAR: 'Desenhar',
            ESCREVER: 'Escrever',
            DIGITE_SUA_ASSINATURA: 'Digite sua assinatura',
            ASSINE_AQUI: 'ASSINE ABAIXO',
            NAO_PRECISA_RG: 'não precisa ser idêntica ao RG',
            OU_CLIQUE_EM: 'Ou clique em',
            PARA_DIGITAR_A_ASSINATURA: 'para digitar a assinatura',
            TROCAR_FONTE: 'Trocar fonte',
            PERMISSAO_DOWNLOAD: 'Só quem já assinou pode fazer download dos arquivos',
            TITULO_PERMISSAO_DOWNLOAD: 'Ainda não é permitido'
        },
        SUCCESS: {
            PRONTO: 'Pronto',
            DOCUMENTO_ASSINADO: 'Documento assinado',
            QUANDO_TODAS_AS_PARTES_ASSINAREM: 'Quando todas as partes assinarem, você receberá um e-mail com um documento assinado.',
            FACILITE_SUAS_ASSINATURAS: '',
            CHAVE_DOCUMENTO: 'Chave do documento',
            CONTRATE_A_GO: 'Gostaria de contratar a Go Contratos para sua empresa?',
            CRIAR_CONTA: 'QUERO CRIAR MINHA CONTA'
        },
        ERROR: {
            PAGE_NOT_FOUND: 'Esta página não está mais disponível.'
        }
    }

    en_US: any = {
        HOME: {
            TITLE: "WELCOME",
            TEST_FREE: "FREE 14 DAYS",
            TEST_14_FREE: "TEST FREE 14 DAYS",
            NO_NEED_CREDIT_CARD: "* No need of credit card",
            HELP_COMPANY: "The funnel that will help your company save money and have more agility",
            TEXT_ENTER: "ENTER",
            FORGET_PASSWORD: "FORGOT PASSWORD? CLICK HERE",
            ACCESS_ACCOUNT: "ACCESS YOUR ACCOUNT",
            CHOICE_RIGHT: "Make the right choice, hire a digital signature of guaranteed quality and legal validity.",
            REGISTER: "Register",
            HAVE_ACCOUNT: "HAVE ACCOUNT? CLICK HERE",
            CREATE: "CREATE",
            COMPLETE_NAME: "complete name",
            CORPORATIVE_EMAIL: "corporative email",
            USER_NAME: "user name",
            PASSWORD: "password",
            COMPANY_NAME: "company name",
            COMPANY_DOCUMENT: "company document",
            THE_SOFTWARE: "THE SOFTWARE",
            PRICE: "PRICE",
            CONTENT: "CONTENT",
            ABOUT: "ABOUT US",
            CONTACT: "CONTACT",
            CHANGE_LANGUAGE: "CHANGE LANGUAGE"
        },
        SIGNATURE: {
            ASSINAR_COMO: 'Sign as ',
            NOME_COMO_NO_CPF: 'Full name (according to CPF)',
            NUMERO_CPF: 'CPF',
            DOCUMENTO_INVALIDO: 'Invalid document',
            DATA_DE_NASCIMENTO: 'Date of birth',
            ESTOU_DE_ACORDO: 'I AGREE - SIGN',
            CANCELAR: 'Cancel',
            PRE_TERMOS_DE_USO: 'by subscribing you agree with the',
            TERMOS_DE_USO: 'terms of use',
            AMBIENTE_SEGURO: 'GoContratos safe environment',
            EVENTOS_DO_DOCUMENTO: 'Document Events',
            ASSINOU_COMO: 'signed as a ',
            VER_ASSINANTES: 'VIEW SUBSCRIBERS',
            PENDENTE: 'PENDING',
            ASSINOU_COMO_UPERCASE: 'SIGNED AS A ',
            SEU_DOCUMENTO: 'YOUR DOCUMENT',
            ASSINAR_COMO_UPERCASE: 'SIGN AS',
            DOWNLOAD_PDF: 'Signed document (PDF)',
            DOWNLOAD_ZIP: 'Original document (PDF)',
            SUA_ASSINATURA_USE: 'Your signature (use',
            OU: 'or',
            PARA_ASSINAR: 'to sign',
            LIMPAR: 'clean',
            DESENHAR: 'Draw',
            ESCREVER: 'write',
            DIGITE_SUA_ASSINATURA: 'Enter your signature',
            ASSINE_AQUI: 'SIGN ABOVE',
            NAO_PRECISA_RG: 'does not need to be identical to the ID',
            OU_CLIQUE_EM: 'Or click',
            PARA_DIGITAR_A_ASSINATURA: 'to enter the signature',
            TROCAR_FONTE: 'Change font',
            PERMISSAO_DOWNLOAD: 'Only those who have already signed can download the files',
            TITULO_PERMISSAO_DOWNLOAD: 'Not allowed yet'
        },
        SUCCESS: {
            PRONTO: 'Ready',
            DOCUMENTO_ASSINADO: 'Signed document',
            QUANDO_TODAS_AS_PARTES_ASSINAREM: 'When all parties sign, you will receive an email with a signed document.',
            FACILITE_SUAS_ASSINATURAS: 'Facilitate your next signatures, save your data for the next documents. Click here',
            CHAVE_DOCUMENTO: 'Document key',
            CONTRATE_A_GO: 'Would you like to hire Go Contracts for your company?',
            CRIAR_CONTA: 'I WANT TO CREATE MY ACCOUNT'
        },
        ERROR: {
            PAGE_NOT_FOUND: 'This page is no longer available.'
        }
    }

    getLanguage(): any {
        this.language = localStorage.getItem("language");
        if (this.language) {
            if (this.language == "pt_BR") {
                return this.pt_BR;
            } else {
                return this.en_US;
            }
        } else {
            this.language = "pt_BR";
            return this.pt_BR;
        }
    }

    setLanguage(language: string) {

        this.language = language;
        localStorage.setItem("language", language);
        window.location.reload();
    }


}
